module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Medium.woff
// module id = 273
// module chunks = 0